import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, TextField } from "@mui/material";
import { useState } from "react";

import { GeoRehandleDTO } from "../../../DTOs/Geology/GeoRehandleDTO";

type MovementToCellProps = {
  entry: GeoRehandleDTO,
  locationOptions: { value: number, label: string, isDumpOrCrusher: boolean }[],
  locationOptionsLoading: boolean,
  handleUpdateRow: (row: GeoRehandleDTO) => Promise<boolean | undefined>
  isShiftLocked: boolean
}

const MovementToCell: React.FC<MovementToCellProps> = ({
  entry,
  locationOptions,
  locationOptionsLoading,
  handleUpdateRow,
  isShiftLocked
}) => {
  const [isLoading, setLoading] = useState(false);

  return (
    <Autocomplete
      disabled={isShiftLocked}
      classes={{ root: 'w-full' }}
      size="small"
      loading={locationOptionsLoading}
      options={locationOptions}
      value={locationOptions.find(x => x.value === entry.movementToId) ?? null}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onChange={async (_event, newValue) => {
        if (newValue) {
          setLoading(true);
          await handleUpdateRow(
            { ...entry, movementToId: newValue.value }
          );
          setLoading(false);
        }
      }}
      renderOption={(props, option) => (
        <li {...props}>
          <span
            className={`${option.isDumpOrCrusher === true ? "text-theme-danger" : ""}`}>{option.label}</span>
        </li>
      )}
      renderInput={(params) => {
        return <TextField
          {...params}
          label="Movement To"
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps.input,
              className: `${locationOptions.find(x => x.value === entry.movementToId)?.isDumpOrCrusher === true ? "text-theme-danger" : ""}`,
              style: {
                transition: "color 0.2s ease-in-out"
              },
              endAdornment: (
                <>
                  {(isLoading || locationOptionsLoading) &&
                    <FontAwesomeIcon icon={faSpinner} spin />}
                  {params.slotProps.input.endAdornment}
                </>
              )
            }
          }}
        />
      }}
    />);
};

export default MovementToCell;